import { Select } from 'antd';
import React from 'react';

const ORIGIN_OPTIONS = [
  '1st Party Catering',
  '1st Party Main Menu',
  'Catering Team',
  'NCC',
  'PeopleLinx',
  'Crumbs',
  'Wedding Pro',
  '3rd Party Catering',
  'Inbound',
  'Store',
].map((value) => ({ value, label: value }));

function SourceInput(props) {
  return <Select options={ORIGIN_OPTIONS} {...props} />;
}

export default SourceInput;
